    // ---------- Utilidades ----------
    const formatoPrecio = (n) =>
      new Intl.NumberFormat("es-CL", { style: "currency", currency: MARCA.moneda, maximumFractionDigits: 0 }).format(n);
    const enlaceWhatsApp = (texto) =>
      `https://wa.me/${MARCA.whatsapp}?text=${encodeURIComponent(texto)}`;
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

    // ---------- Datos de marca en la página ----------
    document.querySelectorAll("[data-marca]").forEach((el) => {
      const valor = MARCA[el.dataset.marca];
      if (valor) el.textContent = valor;
    });
    document.getElementById("anio").textContent = new Date().getFullYear();
    document.getElementById("dato-email").textContent = MARCA.email;
    document.getElementById("dato-email").href = `mailto:${MARCA.email}`;
    document.getElementById("pie-tiktok").href = MARCA.tiktok;
    document.getElementById("pie-grupo").href = MARCA.grupoWhatsapp;
    document.getElementById("enlace-grupo").href = MARCA.grupoWhatsapp;
    document.querySelectorAll("[data-live]").forEach((el) => {
      const valor = MARCA.live[el.dataset.live];
      if (valor) el.textContent = valor;
    });
    document.getElementById("enlace-live").href = MARCA.live.enlace;

    // ---------- Aviso "Estamos en vivo" ----------
    // En Shopify la configuración viene del editor del tema (window.XOXO_LIVE); en la web local, de MARCA.live.
    // Con ?envivo=1 en la dirección se ve encendido para probar.
    const cfgLive = window.XOXO_LIVE || MARCA.live;
    const DIAS = ["dom", "lun", "mar", "mie", "jue", "vie", "sab"];
    const NOMBRE_DIA = { lun: "lunes", mar: "martes", mie: "miércoles", jue: "jueves", vie: "viernes", sab: "sábados", dom: "domingos" };
    const aMinutos = (hhmm) => { const m = /^(\d{1,2})[:.](\d{2})$/.exec(String(hhmm || "").trim()); return m ? +m[1] * 60 + +m[2] : null; };
    function enVivoAhora() {
      if (new URLSearchParams(location.search).has("envivo") || cfgLive.modo === "encendido") return true;
      if (cfgLive.modo !== "horario") return false;
      const ini = aMinutos(cfgLive.inicio), fin = aMinutos(cfgLive.fin), dias = cfgLive.dias || [];
      if (ini === null || fin === null || !dias.length) return false;
      // Día y hora actuales en Chile, aunque el cliente esté en otro país
      const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: "America/Santiago", weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
        .formatToParts(new Date()).map((x) => [x.type, x.value]));
      const hoy = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(p.weekday);
      const ahora = +p.hour * 60 + +p.minute;
      if (ini < fin) return dias.includes(DIAS[hoy]) && ahora >= ini && ahora < fin;
      // Live que pasa la medianoche (ej. 22:00 a 01:00)
      return (dias.includes(DIAS[hoy]) && ahora >= ini) || (dias.includes(DIAS[(hoy + 6) % 7]) && ahora < fin);
    }
    const enlaceVivo = cfgLive.enlaceLive || MARCA.live.enlaceLive || MARCA.live.enlace.replace(/\/$/, "") + "/live";
    document.getElementById("live-aviso").href = enlaceVivo;
    if (cfgLive.modo === "horario" && (cfgLive.dias || []).length && aMinutos(cfgLive.inicio) !== null) {
      const dias = DIAS.slice(1).concat("dom").filter((d) => cfgLive.dias.includes(d)).map((d) => NOMBRE_DIA[d]);
      const lista = dias.length > 1 ? dias.slice(0, -1).join(", ") + " y " + dias[dias.length - 1] : dias[0];
      document.querySelectorAll('[data-live="horario"]').forEach((el) => {
        el.textContent = `Lives los ${lista} de ${cfgLive.inicio} a ${cfgLive.fin} (hora de Chile)`;
      });
    }
    function pintarEnVivo() {
      const activo = enVivoAhora();
      document.body.classList.toggle("en-vivo-activo", activo);
      const b = document.getElementById("enlace-live");
      b.href = activo ? enlaceVivo : MARCA.live.enlace;
      b.textContent = activo ? "🔴 Entrar al live ahora" : "Seguir en TikTok";
    }
    pintarEnVivo();
    setInterval(pintarEnVivo, 60000); // aparece y desaparece solo, sin recargar

    // ---------- Categorías: tarjetas, filtros y select del formulario en filtros.js ----------

    // ---------- FAQ ----------
    document.getElementById("lista-faq").innerHTML = FAQ.map((f) =>
      `<details><summary>${esc(f.p)}</summary><p>${esc(f.r)}</p></details>`).join("");

    // ---------- Enlaces de WhatsApp ----------
    document.querySelectorAll(".js-wa").forEach((a) => {
      a.href = enlaceWhatsApp(a.dataset.msg || "Hola");
      a.target = "_blank";
      a.rel = "noopener";
    });

    // ---------- Formulario → WhatsApp ----------
    document.getElementById("form-pedido").addEventListener("submit", (e) => {
      e.preventDefault();
      const f = e.target;
      for (const campo of [f.nombre, f.ciudad]) {
        if (!campo.value.trim()) { campo.focus(); campo.reportValidity?.(); return; }
      }
      const texto = [
        `Hola, soy ${f.nombre.value.trim()} (${f.ciudad.value.trim()}).`,
        `Quiero cotizar: ${f.cantidad.value || 1} x ${f.categoria.value}.`,
        `Entrega: ${f.entrega.value}.`,
        f.mensaje.value.trim() && `Comentarios: ${f.mensaje.value.trim()}`,
      ].filter(Boolean).join("\n");
      window.open(enlaceWhatsApp(texto), "_blank", "noopener");
    });

    // ---------- Videos de secciones ----------
    document.querySelectorAll("video[data-asset]").forEach((v) => { v.src = window.XOXO_ASSET[v.dataset.asset]; });

    // ---------- Menú móvil ----------
    const boton = document.querySelector(".menu-boton");
    const nav = document.getElementById("nav");
    boton.addEventListener("click", () => {
      const abierto = nav.classList.toggle("abierto");
      boton.setAttribute("aria-expanded", abierto);
    });
    nav.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => {
      nav.classList.remove("abierto");
      boton.setAttribute("aria-expanded", "false");
    }));
